<style lang="scss" scoped>
.content {
    width: 100%;
    height: auto;
    display: block;
    // justify-content: space-between;
    position: relative;
    padding-top: 1px;
    .content-right {
      // width: 84%;
      // height: 100%;
      // margin-left: 2%;
      // margin-left: 286px;
      width: 90%;
      position: relative;
      margin: 0 auto;
      .category-div {
      width: 100%;
      background-color:#f5f7fa;
      height: 100px;
      text-align: left;
      margin:16px 0;
      .title {
        font-size: 18px;
        font-weight: bold;
        margin-left: 20px;
        padding-top: 10px;
      }
      .intro {
        width: 97%;
        margin: 10px 2% 20px 1%;
        background-color: #fff;
        border:1px solid #ebebeb;
        height: 45px;
        padding-left: 10px;
        font-size: 12px;
        padding-top: 10px;
        color: #666;
      }
    }
    .paper-info {
      width:100%;
      height: 70px;
      background-color: #fff;
      // padding-top: 10px;
      .paper-title {
        line-height: 70px;
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }
    }
    .question-div,.opt-div {
      width: 100%;
      min-height: 120px;
      background-color: #fff;
      text-align: left;
      padding: 20px 2% 0px;
      color: #666;
      position: relative;
      // font-size: 18px;
      // border-bottom: 1px solid #ebebeb;
      margin-bottom: 10px;
      .student-answer {
        color: #3198ff;
        margin:10px 0;
        position:relative;
        max-width: 900px;
        white-space: normal;
        word-break: break-all;
        line-height: 19px;
        ::v-deep pre {
          max-width: 900px;
          display: inline-block;
          margin: 0px;
          vertical-align: text-top;
        }
        ::v-deep p {
          margin: 0px;
          vertical-align: text-top;
          max-width: 900px;
          display: inline-block;
        }
        ::v-deep img {
          margin-top: 10px;
          width: 35%;
        }
      }
      .score {
        // position: absolute;
        // right: 10px;
        // bottom: 10px;
        text-align: right;
        span {
          // width: 100px;
          // height: 30px;
          padding: 8px 4px;
          background-color: #09c56d;
          text-align: center;
          color: #fff;
          font-weight: bold;
          border-radius: 4px;
        }
      }
    }
    .question-title {
      // font-weight: bold;
      color: #333;
      max-width: 900px;
      white-space: normal;
      word-break: break-all;
      font-size: 18px;
      ::v-deep p {
        max-width: 900px;
      }
      ::v-deep pre {
        max-width: 900px;
        white-space: normal;
        word-break: break-all;
      }
      ::v-deep img {
        margin-top: 10px;
        max-width: 100%;
      }
    }
    .right-answer {
      color: #333;
      margin-bottom: 10px;
      max-width: 900px;
      white-space: normal;
      word-break: break-all;
      line-height: 19px;
      ::v-deep pre {
        max-width: 900px;
        margin: 0px;
        display: inline-block;
        vertical-align: text-top;
      }
      ::v-deep p {
        max-width: 900px;
        margin: 0px;
        display: inline-block;
        vertical-align: text-top
      }
      ::v-deep img {
        margin-top: 4px;
        max-width: 100%;
      }
    }
    .knowledge-div {
      max-width: 900px;
      white-space: normal;
      word-break: break-all;
    }
    .knowledge {
      color: #3198ff;
      ::v-deep p {
        display: inline-block;

      }
    }
    .p-title {
      margin:10px 0;
      line-height: 19px;
    }
    .div-right {
      background-color: #81beaa;
      // background-color: seagreen
    }
    .div-error {
      // deb1b1
      background-color: #cc6666;
    }
    .blue-div {
      // background-color: #86c0e6;
    }
    .p-right-title {
      color:seagreen;
    }
    .p-error-title {
      color: red;
    }
    .option-txt {
      max-width: 900px;
      display: inline-block;
      vertical-align: top;
      white-space: normal;
      word-break: break-all;
      font-size: 18px;
      vertical-align: text-top;
      margin-top: -1px;
      ::v-deep p{
        padding-top: 2px;
        ::v-deep img {
          max-width: 100%;
          margin-top: 10px;
        }
        ::v-deep span {
            /*color: #b3b3b3!important;*/
            background-color: transparent!important;
        }
        ::v-deep sub {
            vertical-align: sub!important;
        }
        ::v-deep sup {
            vertical-align: super!important;
        }
      }
    }
  }
  .iframe-div {
    height: 600px;
  }
  iframe {
    width: 100%;
    height: 100%;
  }
  .code {
    font-size: 16px;
    margin: 6px 0;
  }
  .cover {
    width: 60%;
    height: 300px;
    position: absolute;
    top: 26px;
    background: transparent;
  }
  .basis-input {
    margin-top: 20px;
    margin-bottom: 20px;
    ::v-deep .el-textarea__inner {
      max-height: 159px;
      overflow-y: auto;
    }
  }
  .results-div {
    padding: 6px;
    color: #fff;
    margin: 0 -2.1%;
  }
}
</style>
<template>
  <div class="content">
        <!-- <div class="content-left">
          <div class="box">
            <p style="font-weight:bold">考生信息：</p>
            <p><span class="test-name">考试名称：</span><span class="test-name">{{info.name}}</span></p>
            <p><span class="same-fonts">试卷名称：</span><span class="same-color">{{info.paper_name}}</span></p>
            <p><span class="same-fonts">考生姓名：</span><span class="same-color">{{info.student_name}}</span></p>
            <p><span class="same-fonts">准考证号：</span><span class="same-color">{{info.admission_ticket}}</span></p>
          </div>
          <div class="box option-box">
            <template v-if="problems.length == 0">
            <p>总分：暂无考卷</p>
            </template>
            <template v-else>
              <p style="font-weight:bold">统计：</p>
              <div class="same-div" v-for="item in chooseArr" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>
                <template v-if="item.questions.length != 0">
                  <span>({{item.questions.length}})道：</span>
                  <span class="span-color">
                    {{item.answer_score}}/{{item.total_score}}分
                  </span>
                </template>
              </div>
              <div class="same-div" v-for="item in multipleArr" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>
               <template v-if="item.questions.length != 0">
                  <span>({{item.questions.length}})道：</span>
                  <span class="span-color">
                   {{item.answer_score}}/{{item.total_score}}分
                  </span>
                </template>
              </div>
              <div class="same-div" v-for="item in checkArr" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>
                <template v-if="item.questions.length != 0">
                  <span>({{item.questions.length}})道：</span>
                  <span class="span-color">
                    {{item.answer_score}}/{{item.total_score}}分
                  </span>
                </template>
              </div>
              <div class="same-div" v-for="item in blankArr" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>
               <template v-if="item.questions.length != 0">
                  <span>({{item.questions.length}})道：</span>
                  <span class="span-color">
                    {{item.answer_score}}/{{item.total_score}}分
                  </span>
                </template>
              </div>
              <div class="same-div" v-for="item in optsArr" :key="item.id">
                <span v-html="item.title">{{item.title}}</span>
                <template v-if="item.questions.length != 0">
                  <span>({{item.questions.length}})道：</span>
                  <span class="span-color">
                   {{item.answer_score}}/{{item.total_score}}分
                  </span>
                </template>
              </div>
              <p><span>总分：</span><span>{{get_score}}/{{total_score}}分</span></p>
            </template>
          </div>
          <div class="box">
            <p><span class="same-fonts">考试日期：</span><span class="same-color">{{info.date}}</span></p>
            <p><span class="same-fonts">考试时间：</span><span class="same-color">{{info.time}}</span></p>
            <p><span class="same-fonts">考试时长：</span><span class="same-color">{{info.duration}}</span></p>
          </div>
        </div> -->
        <div class="content-right">
          <div class="paper-info">
            <p class="paper-title">{{info.paper_name}}</p>
          </div>
          <div v-if="problems.length == 0">暂无试卷数据！</div>
          <div class="preview paper-content ql-snow" v-else>
            <div v-for="outItem in chooseArr" :key="outItem.id">
            <div class="category-div" v-if="chooseArr.length > 0">
              <p class="title" v-html="outItem.title">{{outItem.title}}</p>
              <div>
                <div class="intro">{{outItem.description}}</div>
              </div>
            </div>
            <div class="question-div ql-editor" v-for="(item) in outItem.questions" :key="item.id">
              <p v-html="item.question_title" class="question-title">{{item.question_title}}</p>
              <template v-for="(subEle,index) in item.options">
                <template v-if="subEle.is_student_check == 1">
                  <p class="p-title" :key="subEle.id" :class="subEle.is_check_true && subEle.is_check_true == 1 ? 'p-right-title' : 'p-error-title'"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
                <template v-else>
                  <p class="p-title" :key="subEle.id"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
              </template>
              <div class="student-answer">
                <span>学生答案：</span>
                <template v-if="Object.keys(item.examinee_answer).length > 0">
                  <span v-html="item.examinee_answer.answer">{{item.examinee_answer.answer}}</span>
                </template>
              </div>
              <div class="right-answer"><span>正确答案：</span><span v-html="item.answer">{{item.answer}}</span></div>
              <div class="results-div" :class="item.is_check_true == 1 ? 'div-right' : 'div-error'">
                <p><span>答题结果：</span>
                <span v-if="item.is_check_true">正确</span><span v-else>错误</span>
                <span>&nbsp;&nbsp;</span>
                <span v-if="item.marking_record.length > 0">得分：{{item.marking_record[0].score}}分</span>
                <span v-else>无阅卷记录</span>
                </p>
              </div>
            </div>
            </div>
            <div v-for="outItem in multipleArr" :key="outItem.id">
            <div class="category-div" v-if="multipleArr.length > 0">
              <p class="title" v-html="outItem.title">{{outItem.title}}</p>
              <div>
                <div class="intro">{{outItem.description}}</div>
              </div>
            </div>
            <div class="question-div ql-editor" v-for="(item) in outItem.questions" :key="item.id">
              <p v-html="item.question_title" class="question-title">{{item.question_title}}</p>
              <template v-for="(subEle,index) in item.options">
                <template v-if="subEle.is_student_check == 1">
                  <p class="p-title" :key="subEle.id" :class="(subEle.is_student_check && subEle.is_student_check == 1) && subEle.is_true == 1 ? 'p-right-title' : 'p-error-title'"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
                <template v-else>
                  <p class="p-title" :key="subEle.id"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
              </template>
              <div class="student-answer">
                <span>学生答案：</span>
                <template v-if="item.choose_option.length > 0">
                  <template v-for="(oItem,oIndex) in item.choose_option">
                    <span :key="oItem">选项{{oItem+1}}<span v-if="oIndex < item.choose_option.length -1">、</span></span>
                  </template>
                </template>
              </div>
              <div class="right-answer"><span>正确答案：</span><span v-html="item.answer">{{item.answer}}</span></div>
              <div class="results-div" :class="item.is_check_true == 1 ? 'div-right' : 'div-error'">
                <p><span>答题结果：</span>
                <span v-if="item.is_check_true">正确</span><span v-else>错误</span>
                <span>&nbsp;&nbsp;</span>
                <span v-if="item.marking_record.length > 0">得分：{{item.marking_record[0].score}}分</span>
                <span v-else>无阅卷记录</span>
                </p>
              </div>
            </div>
            </div>
            <div v-for="outItem in checkArr" :key="outItem.id">
            <div class="category-div" v-if="checkArr.length > 0">
              <p class="title" v-html="outItem.title">{{outItem.title}}</p>
              <div>
                <div class="intro">{{outItem.description}}</div>
              </div>
            </div>
            <div class="question-div ql-editor" v-for="(item) in outItem.questions" :key="item.id">
              <p v-html="item.question_title" class="question-title">{{item.question_title}}</p>
              <template v-for="(subEle,index) in item.options">
                <template v-if="subEle.is_student_check == 1">
                  <p class="p-title" :key="subEle.id" :class="subEle.is_check_true && subEle.is_check_true == 1 ? 'p-right-title' : 'p-error-title'"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
                <template v-else>
                  <p class="p-title" :key="subEle.id"><span style="font-size:18px;line-height:22px">{{String.fromCharCode(65 + index)}}&nbsp;&nbsp;</span><span v-html="subEle.option_title" class="option-txt">{{subEle.option_title}}</span></p>
                </template>
              </template>
              <div class="student-answer">
                <span>学生答案：</span>
                <template v-if="Object.keys(item.examinee_answer).length > 0">
                  <span v-html="item.examinee_answer.answer">{{item.examinee_answer.answer}}</span>
                </template>
              </div>
              <div class="right-answer"><span>正确答案：</span><span v-html="item.answer">{{item.answer}}</span></div>
              <div class="results-div" :class="item.is_check_true == 1 ? 'div-right' : 'div-error'">
                <p><span>答题结果：</span>
                <span v-if="item.is_check_true">正确</span><span v-else>错误</span>
                <span>&nbsp;&nbsp;</span>
                <span v-if="item.marking_record.length > 0">得分：{{item.marking_record[0].score}}分</span>
                <span v-else>无阅卷记录</span>
                </p>
              </div>
            </div>
            </div>
            <div v-for="outItem in blankArr" :key="outItem.id">
            <div class="category-div" v-if="blankArr.length > 0">
              <p class="title" v-html="outItem.title">{{outItem.title}}</p>
              <div>
                <div class="intro">{{outItem.description}}</div>
              </div>
            </div>
            <div class="question-div blue-div ql-editor" v-for="(item) in outItem.questions" :key="item.id">
              <p v-html="item.question_title" class="question-title">{{item.question_title}}</p>
              <div class="student-answer">
                <span>学生答案：</span>
                <template v-if="item.completion_count == 0">
                  <span>该学生未作答</span>
                </template>
                <template v-for="(ele) in item.blanks_arr" v-else>
                  <span :key="ele.id">（{{ele}}）</span>
                </template>
              </div>
              <div class="right-answer"><span>正确答案：</span><span v-html="item.answer">{{item.answer}}</span></div>
              <div class="results-div" :class="item.marking_record.length > 0 && item.score == item.marking_record[0].score ? 'div-right' : 'div-error'">
                <p><span>答题结果：</span>
                <span v-if="item.marking_record.length > 0">{{item.marking_record[0].score}}分</span>
                <span v-else>零分</span>
                <span>&nbsp;&nbsp;</span>
                <span v-if="item.marking_record.length > 0">
                  <span>得分：{{item.marking_record[0].score}}分</span>
                  <span>/</span>
                  <span>{{item.score}}分</span>
                </span>
                <span v-else>无阅卷记录</span>
                </p>
              </div>
            </div>
            </div>
            <div v-for="outItem in optsArr" :key="outItem.id">
            <div class="category-div" v-if="optsArr.length > 0">
              <p class="title" v-html="outItem.title">{{outItem.title}}</p>
              <div>
                <div class="intro">{{outItem.description}}</div>
              </div>
            </div>
            <div class="opt-div blue-div ql-editor" v-for="(item) in outItem.questions" :key="item.id">
              <p v-html="item.question_title" class="question-title">{{item.question_title}}</p>
              <div class="student-answer">
                <!-- <span>学生答案：</span>
                <template v-if="!is_c_ide">
                  <el-button type="primary" class="to-works" size="small" @click="toWork(item)">查看作品</el-button>
                </template>
                <template v-else>
                  <template v-if="item.examinee_answer.length > 0">
                    <editor class="code" ref="code" id="code" v-model="item.examinee_answer[0].answer" lang="c_cpp" theme="monokai" width="60%" height="300px"></editor>
                    <div class="cover"></div>
                  </template>
                </template> -->
              </div>
              <div class="right-answer"><span>正确答案：</span><span v-html="item.answer">{{item.answer}}</span></div>
              <el-input type="textarea" class="basis-input" v-if="item.marking_record.length > 0 && item.marking_record[0].basis != ''" v-model="item.marking_record[0].basis" readonly="readonly" :autosize="{minRows: 7}" resize="none"></el-input>
              <div class="results-div" :class="item.marking_record.length > 0 && item.score == item.marking_record[0].score ? 'div-right' : 'div-error'">
                <p><span>答题结果：</span>
                <span v-if="item.marking_record.length > 0">{{item.marking_record[0].score}}分</span>
                <span v-else>零分</span>
                <span>&nbsp;&nbsp;</span>
                <span v-if="item.marking_record.length > 0">
                  <span>得分：{{item.marking_record[0].score}}分</span>
                  <span>/</span>
                  <span>{{item.score}}分</span>
                </span>
                <span v-else>无阅卷记录</span>
                </p>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
</template>
<script>
import {
  getSeeGrade,
} from '@/services/getData';
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      info: {
        name: '',
        paper_name: '',
        student_name: '',
        admission_ticket: '',
        date: '',
        time: '',
        duration: '',
        radio_score: '',
        fill_score: '',
        judge_score: '',
        opt_score: ''
      },
      problems: [],
      chooseArr: [],
      multipleArr: [],
      checkArr: [],
      blankArr: [],
      optsArr: [],
      category_type: null,
      total_score: 0,
      get_score: 0,
    };
  },
  components: {
    // editor: require('vue2-ace-editor')
  },
  methods: {
    fetchData() {
      let id = this.$route.query.id;
      getSeeGrade(id).then(res => {
        console.log(res);
        this.chooseArr = [];
        this.multipleArr = [];
        this.checkArr = [];
        this.blankArr = [];
        this.optsArr = [];
        this.info.paper_name = res.examination.examination_paper_title;
        this.problems = res.examination.major_problems;
        this.get_score = res.subjective_score + res.objective_score;
        var student_score = 0;
        this.problems.forEach((item) => {
          var chose_score = 0;
          var check_score = 0;
          var blank_score = 0;
          var opts_score = 0;
          var mul_score = 0;
          if (item.category == 1) {
            this.chooseArr.push(item);
          }
          if (item.category == 5) {
            this.multipleArr.push(item);
          }
          if (item.category == 2) {
            this.checkArr.push(item);
          }
          if (item.category == 3) {
            this.blankArr.push(item);
          }
          if (item.category == 4) {
            this.optsArr.push(item);
          }
          item.questions.forEach((ele,eleIndex) => {
            if (ele.category == 1) {
              student_score += ele.score;
              // 判断学生答题正确错误情况
              ele.options.forEach((subEle) => {
                if (Object.keys(ele.examinee_answer.length > 0)) {
                  if (subEle.id == ele.examinee_answer.question_option_id) {
                    subEle['is_student_check'] = 1;
                  }
                  else {
                    subEle['is_student_check'] = 0;
                  }
                }
                if (subEle.is_true == 1) {
                  if (Object.keys(ele.examinee_answer.length > 0)) {
                    if (subEle.id == ele.examinee_answer.question_option_id) {
                      subEle['is_check_true'] = 1;
                      ele['is_check_true'] = 1;
                    }
                    else {
                      subEle['is_check_true'] = 0;
                      ele['is_check_true'] = 0;
                    }
                  }
                }
              });
              if (ele.marking_record.length > 0) {
                chose_score += ele.marking_record[0].score;
              }
              item['answer_score'] = chose_score;
            }
            if (ele.category == 2) {
              student_score += ele.score;
              // 判断学生答题正确错误情况
              ele.options.forEach((subEle) => {
                if (Object.keys(ele.examinee_answer.length > 0)) {
                  if (subEle.id == ele.examinee_answer.question_option_id) {
                    subEle['is_student_check'] = 1;
                  }
                  else {
                    subEle['is_student_check'] = 0;
                  }
                }
                if (subEle.is_true == 1) {
                  if (Object.keys(ele.examinee_answer.length > 0)) {
                    if (subEle.id == ele.examinee_answer.question_option_id) {
                      subEle['is_check_true'] = 1;
                      ele['is_check_true'] = 1;
                    }
                    else {
                      subEle['is_check_true'] = 0;
                      ele['is_check_true'] = 0;
                    }
                  }
                }
              });
              if (ele.marking_record.length > 0) {
                check_score += ele.marking_record[0].score;
              }
              item['answer_score'] = check_score;
            }
            if (ele.category == 3) {
              student_score += ele.score;
              if (ele.completion_count > 0) {
                if (Object.keys(ele.examinee_answer.length > 0)) {
                  var blanks = ele.examinee_answer.answer.split(';');
                  var baseTransfer = blanks.map(x => Base64.decode(x));
                  // console.log(baseTransfer);
                  ele['blanks_arr'] = baseTransfer;
                }
              }
              if (ele.marking_record.length > 0) {
                blank_score += ele.marking_record[0].score;
              }
              item['answer_score'] = blank_score;
            }
            if (ele.category == 4) {
              student_score += ele.score;
              if (ele.marking_record.length > 0) {
                opts_score += ele.marking_record[0].score;
              }
              item['answer_score'] = opts_score;
            }
            if (ele.category == 5) {
              student_score += ele.score;
              // 判断学生答题正确错误情况
              if (Object.keys(ele.examinee_answer.length > 0)) {
                var answerArr = ele.examinee_answer.answer.split(',');
              }
              // console.log(answerArr,'ans');
              var trueArr = [];
              var checkArr = [];
              var optionArr = [];
              ele.options.forEach((subEle,subIndex) => {
                if (Object.keys(ele.examinee_answer.length > 0)) {
                  answerArr.forEach((aItem,aIndex) => {
                    if (subEle.id == aItem) {
                      optionArr.push(subIndex);
                      subEle['is_student_check'] = 1;
                    }
                    // else {
                    //   // subEle['is_student_check'] = 0;
                    // }
                  });
                }
                if (subEle.is_true == 1) {
                  trueArr.push('T');
                  if (ele.examinee_answer.length > 0) {
                    answerArr.forEach((aItem,aIndex) => {
                       if (subEle.id == aItem) {
                         checkArr.push('CT');
                       }
                    });
                  }
                }
              });
              ele['choose_option'] = optionArr;
              if (trueArr.length == checkArr.length) {
                ele['is_check_true'] = 1;
              }
              else {
                ele['is_check_true'] = 0;
              }
              if (ele.marking_record.length > 0) {
                mul_score += ele.marking_record[0].score;
              }
              item['answer_score'] = mul_score;
            }
          });
        });
        this.total_score = student_score;
      }).catch(err => {

      });
    },
    // editorInit() {
    //   require('brace/ext/language_tools');
    //   require('brace/mode/c_cpp');    //language
    //   require('brace/theme/monokai');
    //   require('brace/snippets/c_cpp');
    // },
  },
  created() {
    this.fetchData();
  }
}
</script>
